import hyperdom from 'hyperdom'
import scrollToElement from 'scroll-to-element'


function renderScroller () {

  function scroll (element) {
    let menuHeight = document.querySelector(".main-menu").clientHeight
    let pageHeader = document.querySelector(".page-header")?.clientHeight || 0
    scrollToElement(element, {
      offset: -150 - menuHeight - pageHeader,
      ease: 'linear',
      duration: 300,
    })

  }
  return hyperdom.viewComponent({
    onadd (element) {
      scroll(element)
    },

    onupdate (element) {
      scroll(element)
    },

    render () {
      return hyperdom.html('.scroller')
    },
  })
}

function scrollIntoView (vdom, options) {
  return {
    onadd: element => {
      element.scrollIntoView(options || false)
    },
    render: () => vdom,
  }
}

export default {
  renderScroller: renderScroller,
  scrollIntoView: scrollIntoView,
}
